import websocket from '@/websockets'

/**
 * Realtime-поля документа проекта. Раньше на каждое поле была подписка Firebase в компоненте,
 * теперь бэкенд при записи шлёт событие в комнату проекта, а здесь оно попадает в стор.
 * Компоненты читают эти поля из проекта в сторе.
 *
 * path — путь внутри документа проекта, payloadKey — ключ значения в payload события.
 */
export const PROJECT_REALTIME_EVENTS: Record<string, { path: string; payloadKey: string }> = {
    FB_LOADING_CHISAI: { path: 'loading', payloadKey: 'value' },
    FB_LOADING_COMMUNICATION_UPDATE: { path: 'loadingCommunicationUpdate', payloadKey: 'loading' },
    FB_TIMESTAMPS: { path: 'timestamps', payloadKey: 'timestamps' },
    FB_INIT_CHISAI: { path: 'initChisai/GCB2', payloadKey: 'value' },
    FB_NOTIFICATIONS: { path: 'notifcations/GCB2/newData', payloadKey: 'val' },
    FB_ACTIVATION_CHANGED: { path: 'notifcations/GCB2/activationChanged', payloadKey: 'val' },
    FB_MODA_CHANGED: { path: 'notifcations/GCB2/modaChanged', payloadKey: 'val' },
}

let installed = false

export function installProjectRealtime(store: any, getCurrentProjectId: () => string | undefined) {
    if (installed) {
        return
    }
    installed = true

    // Когда по полю последний раз пришло событие. Снимок читается на бэке до отправки ответа,
    // поэтому событие может прийти раньше него — тогда снимок это поле не затирает.
    const lastEventAt = new Map<string, number>()

    const setValue = (projectId: string, path: string, value: any) => {
        store.commit('setProjectValueByPath', { projectId, path, value })
    }

    Object.entries(PROJECT_REALTIME_EVENTS).forEach(([event, { path, payloadKey }]) => {
        websocket.socket.on(event, (data: any) => {
            const payload = Array.isArray(data) ? data[0] : data
            if (!payload || typeof payload !== 'object' || !(payloadKey in payload)) {
                return
            }
            // Старый бэкенд не присылал projectId — тогда событие относится к открытому проекту
            const projectId = payload.projectId ?? getCurrentProjectId()
            if (!projectId) {
                return
            }
            lastEventAt.set(`${projectId}/${path}`, Date.now())
            setValue(projectId, path, payload[payloadKey])
        })
    })

    websocket.onProjectSnapshot(({ projectId, values }, requestedAt) => {
        Object.entries(values || {}).forEach(([path, value]) => {
            if ((lastEventAt.get(`${projectId}/${path}`) ?? 0) >= requestedAt) {
                return
            }
            setValue(projectId, path, value)
        })
    })
}
